import axios from 'axios';

export default axios.create({
  baseURL: 'http://13.127.146.6:5000/api', // 'http://localhost:5000/api/'
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
});
